import React, { useEffect, useState } from 'react';
import { InputSearchGray, Layout, ScrollItemNews } from '../../../components';
import { useDispatch } from 'react-redux';
import { postDataPage, setPageNo, setPageSize } from '../../../redux/newsSlice';
import { useSearchParams } from 'react-router-dom';

const AllNews = () => {
	const [searchParams, setSearchParams] = useSearchParams();
	const [keyword, setKeyword] = useState(searchParams.get('keyword') || '');

	const dispatch = useDispatch<any>();

	const getNewsList = async (page: number, pageSize: number) => {
		const params = {
			pageNo: 0,
			pageSize: 10,
			sortType: 'DESC',
			filter: [
				{
					key: 'name',
					value: keyword,
					operation: 'MATCH',
					conjunction: 'or',
				},
				{
					key: 'content',
					value: keyword,
					operation: 'MATCH',
					conjunction: 'or',
				},
				{
					key: 'content_plain',
					value: keyword,
					operation: 'MATCH',
					conjunction: 'or',
				},
				{
					key: 'active',
					value: true,
					operation: 'EQUAL',
					conjunction: 'and',
				},
			],
		};
		dispatch(postDataPage(params));
		dispatch(setPageNo(page));
		dispatch(setPageSize(pageSize));
	};

	useEffect(() => {
		getNewsList(0, 10);
	}, []);

	return (
		<Layout
			title="All News"
			showNavBar={true}
			showNavigation={false}
		>
			<div className="mt-[4rem]">
				<div className="flex gap-5 justify-between items-center ">
					<InputSearchGray
						value={keyword}
						onChange={(e) => {
							setKeyword(e.target.value);
						}}
						onKeyDown={(e) => {
							if (e.key === 'Enter') {
								getNewsList(0, 10);
							}
						}}
						icon={'FaSistrix'}
						placeholder="Cari Informasi Berita"
					/>
				</div>
				<div className="mt-5">
					<ScrollItemNews
						keyword={keyword}
						fix={false}
					/>
				</div>
			</div>
		</Layout>
	);
};

export default AllNews;
